import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCar2 = function SvgCar2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    fillRule: "evenodd",
    d: "M6 17.083a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m2.279-1.832 8.278-.001a2.331 2.331 0 0 1 4.553 0H22v-2.709a.875.875 0 0 0-.875-.875h-3.667a.5.5 0 0 1-.447-.276L15.316 8h-8.09L5.53 11.39a.5.5 0 0 1-.447.276H3.708a.875.875 0 0 0-.875.875v2.709h.891a2.331 2.331 0 0 1 4.555.001m10.554 1.832a1.334 1.334 0 1 0 0-2.668 1.334 1.334 0 0 0 0 2.668M1.417 15.25h.416v-2.709c0-1.035.84-1.875 1.875-1.875h1.066l1.696-3.39A.5.5 0 0 1 6.917 7h8.708a.5.5 0 0 1 .447.276l1.696 3.39h3.357c1.035 0 1.875.84 1.875 1.875v3.209a.5.5 0 0 1-.5.5h-1.39a2.331 2.331 0 0 1-4.553 0H8.279a2.331 2.331 0 0 1-4.555 0H1.417a.5.5 0 0 1 0-1m11.917-6.416h.917a.5.5 0 0 1 .447.276l.915 1.833a.5.5 0 1 1-.893.447l-.78-1.556h-.606a.5.5 0 0 1 0-1",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCar2);

export { ForwardRef as default };
